import React, { FC } from 'react'
import styles from 'styles/components/tag.module.scss'

type Props = {
  shape?: 'ellipse' | 'square'
  size?: 'medium' | 'large'
  startIcon?: string
  tagName: string
}

const GreenTag: FC<Props> = (props) => {
  const { shape, size, startIcon, tagName } = props
  const baseStyle = styles.tag_green
  const shapeStyle = shape === 'ellipse' ? styles.tag__ellipse : ''
  const sizeStyle = size === 'large' ? styles.tag_large : ''
  const iconStyle = startIcon ? styles.tag__icon : ''

  return (
    <span className={`${baseStyle} ${shapeStyle} ${sizeStyle} ${iconStyle}`}>
      {startIcon && <img src={startIcon} alt={tagName} />}
      {tagName}
    </span>
  )
}

export default GreenTag
